import {
  EventEmitter
} from "events";
import axios from 'axios';
import accountsService from "../accounts/accountsService";

class TCVelikClient extends EventEmitter {
  BASE_ACCOUNT_URL = process.env.VUE_APP_API_URL;

  AuthHeader = '';
  SelectedAccount = '';

  GetDAMDownloadUrl(assetObject){
    return '/api/Dam/Download?id=' + assetObject.Uid;
  }

  constructor() {
    super();

  }

  getToken() {
    let userInfo = accountsService.getUserFromLocalStorage();
    return userInfo?.Token;
  }

  getSelectedAccountId() {
    return localStorage.getItem(location.hostname + "-SelectedAccount");
  }

  getAllAccounts() {
    var userInfo = accountsService.getUserFromLocalStorage();
    return userInfo.AccountPermissions;
  }

  getUserEmail() {
    return localStorage.getItem(location.hostname + "-UserEmail");
  }

  getUserId() {
    return localStorage.getItem(location.hostname + "-UserId");
  }

  getApiKey() {
    return localStorage.getItem("ApiKey");
  }

  changeAccount(newAccountId) {
    localStorage.setItem(location.hostname + "-SelectedAccount", newAccountId);
    window.location.reload();
  }

  selectUserInfo() {

    try {
      let userInfo = accountsService.getUserFromLocalStorage();
      //let selectedAccount = JSON.parse(localStorage.getItem("SelectedAccount"));

      if (!userInfo) {
        return;
      }
    }
    catch (err)
    {
      console.log("USER ERROR", err);
    }
  }

  getSelectedAccount() {
    return {
      
    }
    let userInfo = accountsService.getUserFromLocalStorage();
    let selectedAccountId = localStorage.getItem("SelectedAccount");

    let accountFound = userInfo.AccountPermissions.filter(acc => {
      return acc.Account.Id === (selectedAccountId * 1);
    })[0];

    return accountFound.Account;
  }

  getAnonymousUserId() {
    let anonymousId = localStorage.getItem(location.hostname + '-tcvelik-anonymous-id');
    
    if (!anonymousId) {
      // Generate new anonymous ID using crypto.randomUUID() or fallback
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        anonymousId = crypto.randomUUID();
      } else {
        // Fallback for older browsers
        anonymousId = 'anon_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
      }
      localStorage.setItem(location.hostname + '-tcvelik-anonymous-id', anonymousId);
    }
    
    return anonymousId;
  }

  extendOptions(options) {
    if (!options)
      options = {};
    if (!options.headers)
      options.headers = {};

    var token = localStorage.getItem(location.hostname + "-token");
    var apiKey = this.getApiKey();

    // If we have a token, use authenticated headers
    if (token) {
      options.headers.Authorization = `Bearer ${token}`;
      options.headers.tcauth = `${this.getUserEmail()}~${this.getToken()}`;
      options.headers.account = this.getSelectedAccountId();
      options.headers.user = this.getUserId();
    } else {
      // For anonymous users, add anonymous ID header
      const anonymousId = this.getAnonymousUserId();
      if (anonymousId) {
        options.headers['X-Anonymous-Id'] = anonymousId;
      }
    }

    if (apiKey)
      options.headers.ApiKey = `${apiKey}`;
    
    return options;
  }

  extendUploadHeaders(options) {
    if (!options)
      options = {};
    if (!options.headers)
      options.headers = {};
    var token = localStorage.getItem(location.hostname + "-token");
    options.headers.Authorization = `Bearer ${token}`;
      return options;
  }

  GetRelative(relativeUrl, options) {
    options = this.extendOptions(options);

    return axios.get(this.BASE_ACCOUNT_URL + relativeUrl, options);
  }

  PostRelative(relativeUrl, payload, options) {
    options = this.extendOptions(options);
    return axios.post(this.BASE_ACCOUNT_URL + relativeUrl, payload, options);
  }

  GetSafeFilter(filter) {
    var safeFilter = filter;
    if (!safeFilter || safeFilter.length == 0)
      safeFilter = "";
    else
      safeFilter = encodeURIComponent(safeFilter);

    return safeFilter;
  }
}

export default new TCVelikClient();
